import React from "react";
import Icon from "react-native-vector-icons/Octicons";

const MenuIcon = ({ handler }) => (
  <Icon name="three-bars" size={30} color="#000" onPress={() => handler()} />
);

export default MenuIcon;
